<template>
  <div>
    <b-form @submit.prevent="submit" novalidate>
      <div class="row">
        <div class="col-lg-12">
          <validated-form-input name="paymentDueDays" label="Tähtaeg päevades"
                                v-model="conditions.paymentDueDays"
                                validate="numeric|required" :validator="$validator"/>

          <validated-form-input name="minimumFee" label="Min hind €"
                                v-model="conditions.minimumFee"
                                validate="required|decimal" :validator="$validator"/>

          <validated-form-input name="dailyFeeRate" label="Päeva tasu %"
                                v-model="conditions.dailyFeeRate" :disabled="!!conditions.periodFeeRate"
                                validate="decimal|max_value:100" :validator="$validator"/>

          <validated-form-input name="periodFeeRate" label="Kogu tasu %"
                                v-model="conditions.periodFeeRate" :disabled="!!conditions.dailyFeeRate"
                                validate="decimal|max_value:100" :validator="$validator"/>

          <validated-form-input name="discount" label="Allahindluse %"
                                v-model="conditions.discount"
                                validate="decimal|max_value:100" :decimal="true" :validator="$validator"/>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <submit-button class="float-right" variant="primary">Salvesta</submit-button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import ValidatedFormInput from '@/components/ValidatedFormInput'
import gateway from '@/services/gateway'

export default {
  components: {ValidatedFormInput},
  props: ['client'],
  data() {
    return {
      conditions: Object.assign({
        paymentDueDays: 14,
        minimumFee: '',
        dailyFeeRate: '',
        periodFeeRate: '',
        discount: ''
      }, this.client.paymentConditions)
    }
  },
  methods: {
    submit() {
      this.$validator.validateAll().then((valid) => {
        if (!valid) return
        gateway.post('/clients/' + this.client.id + '/payment-conditions', this.conditions)
          .then(() => this.$notifications.info('Maksetingimused salvestatud'))
          .then(() => this.$emit('done'))
      })
    }
  }
}
</script>
